import Marquee from "react-fast-marquee";

export const BrandMarquee = () => (
  <div className="bg-maroon py-6 border-y border-gold/20" data-testid="brand-marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {["Defining Your Brands Since 1997", "The Railway Advertiser", "Railway Station Advertising", "Digital Display Screens", "Outdoor Hoardings", "Transit Media"].map((t, i) => (
        <span key={i} className="mx-10 inline-flex items-center gap-10">
          <span className="font-display italic text-3xl md:text-5xl text-gold-muted">{t}</span>
          <span className="text-gold text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
